export default __webpack_public_path__ + "static/media/Kupukupu.7843b1d2.png";